<template lang="pug">
.v-field-range.field-range(:class="{'field-range--sm': field.size === 'sm'}")
	label.field-label(v-if="field.label")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-range__cell-title(v-if="field.title" ) {{ field.title }}
	.field-range__cells(:class="{'vertical': field.vertical}")
		.field-range__cell-wrap
			.field-range__prefix(v-if="field.prefixMin") {{field.prefixMin}}
			.field-range__cell
				v-field.field-range__input(v-if="field.mode === 'time'"
						:field="{type: 'text', size: 'sm', mode: 'time' , placeholder: '00:00', mask: { mask: '00:00'}, disabled: field.disabled}"
						v-model="textFrom"
						@update:model-value="inputTime")
				v-field.field-range__input(v-else
						:field="{type: 'text', inputmode: 'decimal', disabled: field.disabled, precision: field.precision, placeholder: field.placeholderMin}"
						v-model="localValue.min"
						@update:model-value="handleInput"
						@keyup.native.enter="emitInput")
			.field-range__postfix(v-if="field.postfixMin") {{field.postfixMin}}
		.field-range__spacer(v-if="!field.vertical" ) —
		.field-range__cell-wrap
			.field-range__prefix(v-if="field.prefixMax") {{field.prefixMax}}
			.field-range__cell
				v-field.field-range__input(v-if="field.mode === 'time'"
						:field="{type: 'text', size: 'sm', mode: 'time' , placeholder: '00:00', mask: { mask: '00:00'}, disabled: field.disabled}"
						v-model="textTo"
						@update:model-value="inputTime")
				v-field.field-range__input( v-else
						:field="{type: 'text', inputmode: 'decimal', disabled: field.disabled, precision: field.precision, placeholder: field.placeholderMax}"
						v-model="localValue.max"
						@update:model-value="handleInput"
						@keyup.native.enter="emitInput")
			.field-range__postfix(v-if="field.postfixMax") {{field.postfixMax}}
</template>

<script>
export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			textFrom: null,
			textTo: null,
			localValue: null,
			debounceTimeout: null
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};

			if(this.field.mode === "time") {
				if(this.localValue && this.localValue.length) {
					const [
						first = null,
						second = null
					] = this.localValue;
					this.textFrom = first;
					this.textTo = second;
				} else {
					this.textFrom = '';
					this.textTo = '';
				}
			}
		},

		inputTime() {
			this.localValue = [ this.textFrom, this.textTo] ;
			this.handleInput();
		},

		handleInput() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(this.emitInput, 1000);
		},

		emitInput() {
			clearTimeout(this.debounceTimeout);
			if (this.field && this.field.mode === !'time') {
				if (typeof this.field.max == 'number' && this.field.max !== Infinity) {
					this.localValue.max = Math.min(this.localValue.max, this.field.max);
				}
				if (typeof this.field.min == 'number' && this.field.max !== -Infinity) {
					this.localValue.min = Math.max(this.localValue.min, this.field.min);
				}

				if (this.localValue.min > this.localValue.max) {
					this.localValue.max = this.field.max;
				}
			}
			this.$emit('update:model-value', this.localValue);
		}
	}
};
</script>
